import axios from 'axios'
import store from '@/store'

const urlPath = '/dps/manager'

export default {
  async parkings(callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/parkings`)
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },
  async list(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/list`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/managerService.js